const initialState = {
  totalUnread: 0,
}

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TOTAL_UNREAD':
      console.log('SET_TOTAL_UNREAD:', action.payload)
      return {
        ...state,
        totalUnread: parseInt(action.payload, 10) || 0,
      }
    case 'INCREMENT_TOTAL_UNREAD':
      console.log('INCREMENT_TOTAL_UNREAD, ancien total:', state.totalUnread)
      return {
        ...state,
        totalUnread: state.totalUnread + 1,
      }
    case 'DECREMENT_TOTAL_UNREAD':
      console.log('DECREMENT_TOTAL_UNREAD, ancien total:', state.totalUnread)
      return {
        ...state,
        totalUnread: Math.max(0, state.totalUnread - 1),
      }
    // Déconnexion : le compteur doit repartir de zéro. La déconnexion depuis
    // l'en-tête est une navigation SPA (`navigate('/login')`), donc le store
    // survit — sans ça, le titre de l'onglet garderait « (3) » sur la page de
    // connexion. Le chemin mobile recharge la page et n'en dépend pas, mais on
    // corrige ici plutôt qu'au point d'appel : la remise à zéro appartient à
    // l'état, pas à un composant.
    case 'user/setUser':
      return action.payload ? state : initialState

    default:
      return state
  }
}

export default messagesReducer
